import styled from 'styled-components';

export const SelectorRightContainer = styled.div`
    flex: 1;
    border: 1px solid ${props => props.theme.whiteGrey};
    padding: 20px 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    & > p > span {
        font-size: 16px;
        font-weight: bold;
    }

    & > p {
        font-size: 16px;
        text-align: center;
    }

    .basket {
        text-transform: uppercase;
    }

    @media (min-width: ${props => props.theme.mobile}) {
        margin-left: 8px;
    }

    .cart-container {
        display: flex;
        flex-direction: column;
        overflow-y: scroll;
        height: 135px;
        padding: 20px 20px;

        & > p {
            text-align: center;
        }

        // For Chrome scrollbar
        &::-webkit-scrollbar {
            width: 10px;
        }
        &::-webkit-scrollbar-thumb {
            background: ${props => props.theme.primary};
            border-radius: 20px;
        }
        &::-webkit-scrollbar-track {
            background: ${props => props.theme.whiteGrey};
            border-radius: 20px;
        }

        // For Firefox scrollbar
        scrollbar-width: thin;
        scrollbar-color: ${props => props.theme.primary} ${props => props.theme.whiteGrey};
    }

    .row-text {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
        font-size: 15px;

        & > p:nth-child(2) {
            margin: 0 0 0 5px;
        }

        & > .amount {
            font-size: 22px;
            min-width: 125px;
            text-align: right;
            margin-left: 5px;
        }
    }

    .row-text:first-child {
        margin-bottom: 8px;
    }

    .colored {
        color: ${props => props.theme.primary};

        p {
            max-width: 300px;
        }
    }

    .cgv-container {
        display: flex;
        align-items: center;
        background-color: ${props => props.theme.whiteFog};
        border-top: 1px solid ${props => props.theme.whiteGrey};
        border-bottom: 1px solid ${props => props.theme.whiteGrey};
        padding: 10px;

        & > label {
            display: block;
            position: relative;
            padding-left: 35px;
            margin: 0 -10px 23px 0;
            cursor: pointer;

            & > input[type='checkbox'] {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                height: 0;
                width: 0;
            }

            & > .checkmark {
                position: absolute;
                top: 0;
                left: 0;
                height: 25px;
                width: 25px;
                border: 1px solid ${props => props.theme.whiteGrey};
                border-radius: 25px;
                background-color: ${props => props.theme.white};
            }

            & > .checkmark:after {
                content: '';
                position: absolute;
                display: none;
            }

            & > input:checked ~ .checkmark:after {
                display: block;
            }
        }

        .label input:checked ~ .checkmark {
            color: ${props => props.theme.secondary};
        }

        .label .checkmark:after {
            left: 8px;
            top: 4px;
            width: 5px;
            height: 10px;
            border: solid ${props => props.theme.secondary};
            border-width: 0 2px 2px 0;
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
        }

        & > p {
            margin: 0;
            padding-left: 10px;
        }
    }

    .resum-container {
        padding: 10px;
        border-top: 1px solid ${props => props.theme.whiteGrey};
    }

    @media (max-width: ${props => props.theme.mobile}) {
        .cart-container {
            height: auto;
        }

        .row-text {
            & > p:nth-child(2) {
                margin-left: 10px;
            }

            .amount {
                margin-left: 10px;
            }
        }
    }

    @media (max-width: ${props => props.theme.large}) {
        .row-text {
            font-size: 13px;

            > .amount {
                font-size: 18px;
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/ebonselector/EbonSelectorRightContainerStyle.js